export default __webpack_public_path__ + "static/media/eyeglass-2.7d1a4426.svg";